import { IPublicSession } from 'state/session';
import { State } from 'utils/state';

export function fullScreenAutomation(state: State<IPublicSession>) {
  state.on('beforechange', (keys, arrValues, arrOldValues, sessionChanges) => {
    // Observe changes only in streamActive and isShared
    if (keys.includes('streamActive') || keys.includes('isShared')) {
      // Base on live state, not the previousState positional: on reset emissions a
      // reverted key may be absent from the payload, and the live state carries its
      // post-reset value while previousState would leak the stale pre-reset one.
      const { streamActive, sharingType, isShared } = {
        ...state.get(),
        ...sessionChanges,
      };

      if (streamActive && sharingType === 'remote' && isShared) {
        state.setValues({ streamFullScreen: true }, { emit: false });
      }

      if (!streamActive || !isShared) {
        state.setValues({ streamFullScreen: false }, { emit: false });
      }
    }
  });
}
